import { PageViewProps } from 'common/hooks';
import { Language } from './cookies-types';

/**
 * Возвращает объект с данными для отправки в событии "GA:pageview"
 * @param {Record<string, string>} cookie
 * @returns {PageViewProps}
 */
export const selectPageViewData = (cookie: Record<string, string>): PageViewProps => ({
  userId: cookie.customerId || null,
  userAuth: cookie['user-auth'] ? 1 : 0,
});

export const getLang = (cookie: Record<string, string>): Language => (cookie?.lang as Language) ?? 'ru';

export const selectIsInspGalleryABEnabled = (cookie: Record<string, string>): boolean => {
  const experimentCookie = cookie['_landing-insp-gallery'];
  const isInspGalleryEnabled = experimentCookie === 'B';
  // _landing-insp-gallery и варианты А - текущий лендос, B - c insp gallery

  return isInspGalleryEnabled;
};
